import React from 'react';
import { ResponsiveBar } from '@nivo/bar';

const BarComponent = (props) => {
  const pct = props.data.data.value / props.data.data.limit;

  let color = 'text-gray-200';
  let left = 0;

  if (props.data.id === 'value') {
    if (pct > 0.8) {
      color = 'text-jcap-500';
    } else {
      color = 'text-jcap-900';
    }
  } else if (props.data.id === 'limit') {
    color = 'text-gray-400';
  }

  if (props.data.id == 'limit')
    return (
      <g transform={`translate(${props.x},${190 - props.height})`}>
        <polygon
          className={`fill-current text-red-200`}
          points="26,-6 26,6 30,0"
        />
        <polygon
          className={`fill-current text-white`}
          points={`${props.width + 1},-6 ${props.width + 1},6 ${props.width -
            3},0`}
        />
        <rect
          width={31}
          height={24}
          className={`fill-current text-red-200`}
          x={0}
          y={0}
          transform="translate(-4,-12)"
          rx={2}
          ry={2}
        />
        <text
          className={`fill-current text-red-800 text-xs flex items-center font-semibold`}
          textAnchor="start"
          x={0}
          y={0}
          transform="translate(-1,-1)"
        >
          {props.data.data.limit}%
        </text>
        <text
          className={`fill-current text-red-800 text-2xs flex items-center font-semibold`}
          textAnchor="start"
          x={0}
          y={0}
          transform="translate(-1,8)"
        >
          LIMIT
        </text>
      </g>
    );

  if (props.data.id == 'value')
    return (
      <g transform={`translate(${props.x},${190 - props.height})`}>
        <g transform={`translate(${left + 27},0)`}>
          <rect
            width={Math.max(0, props.width - 27)}
            height={Math.max(0, props.height - 10)}
            className={`fill-current text-jcap-500`}
            x={0}
            y={0}
            rx={2}
            ry={2}
          />
          <rect
            width={Math.max(0, props.width - 27)}
            height={Math.max(
              0,
              (props.data.data.value - props.data.data.limit) * 1.9,
            )}
            className={`fill-current text-red-800`}
            x={0}
            y={0}
          />
        </g>
        <text
          className={`fill-current text-gray-800 text-sm flex items-center font-semibold  ${
            pct > 1 ? ' text-red-800' : 'text-gray-600'
          }`}
          textAnchor="start"
          y={props.height + 10}
          x={28}
        >
          {props.data.indexValue}
        </text>
        <text
          className={`fill-current text-xs flex items-center font-semibold ${
            pct > 1 ? ' text-red-800' : 'text-gray-600'
          }`}
          textAnchor="start"
          x={0}
          y={0}
          transform={`translate(28,${props.height + 25})`}
        >
          {props.data.data.value}% Exposure
        </text>
      </g>
    );

  if (props.data.id == 'max')
    return (
      <g transform={`translate(${props.x},${190 - props.height})`}>
        <rect
          width={props.width - 27}
          height={props.height - 10}
          className={`fill-current text-jcap-900`}
          x={0}
          y={0}
          transform={`translate(${left + 27},0)`}
          rx={3}
          ry={3}
        />
      </g>
    );
};

const BarChart = ({ data }) => (
  <div className="h-64 -mx-3">
    <ResponsiveBar
      data={data.map((row: any) => ({
        ...row,
        delta: row.limit - row.value,
        max: 100,
      }))}
      groupMode="stacked"
      keys={['max', 'value', 'limit']}
      minValue={0}
      maxValue={100}
      indexBy="bank"
      padding={0.1}
      theme={{ fontFamily: 'Inter' } as any}
      colors={{ scheme: 'paired' }}
      axisTop={null}
      axisRight={null}
      enableGridY={false}
      enableGridX={false}
      margin={{ bottom: 40, top: 0 }}
      enableLabel={true}
      label={(props: any) => {
        return (
          props.id == 'value' && `${props.data.value} / ${props.data.limit}`
        );
      }}
      labelTextColor="#333"
      tooltip={(props) => (
        <div className="px-2 py-1 -m-3 text-xs text-white rounded bg-jcap-700">
          {props.data.value}
        </div>
      )}
      barComponent={BarComponent}
      defs={[
        {
          id: 'value',
          type: 'linearGradient',
          colors: [{ offset: 100, color: '#9ecae1' }],
        },
        {
          id: 'delta',
          type: 'linearGradient',
          colors: [
            { offset: 0, color: '#eee' },
            { offset: 100, color: '#fff' },
          ],
        },
        {
          id: 'nearBreach',
          type: 'linearGradient',
          colors: [
            { offset: 0, color: '#ED8936' },
            // { offset: 100, color: '#9ecae1' },
          ],
        },
        {
          id: 'breach',
          type: 'linearGradient',
          colors: [
            { offset: 0, color: '#d00' },
            // { offset: 100, color: '#9ecae1' },
          ],
        },
      ]}
      fill={[
        {
          match: ({ data }: any) => {
            const pct = data.data.value / data.data.limit;
            return data.id === 'value' && pct >= 1;
          },
          id: 'breach',
        },
        {
          match: ({ data }: any) => {
            const pct = data.data.value / data.data.limit;
            return data.id === 'value' && pct > 0.8;
          },
          id: 'nearBreach',
        },
        { match: { id: 'delta' }, id: 'delta' },
        { match: { id: 'value' }, id: 'value' },
        { match: { id: 'max' }, id: 'max' },
      ]}
      axisLeft={null}
      axisBottom={null}
      animate={true}
      motionStiffness={90}
      motionDamping={15}
      borderRadius={2}
    />
  </div>
);

export default BarChart;
